import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./container.module.scss";

function Container(props) {
  return (
    <div className={classNames(styles.root, props.className)}>
      {props.children}
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.array
  ]),
  className: PropTypes.string
};

export default Container;
